import React from "react";
import ProjectItem from "../components/ProjectItem";
import CommandHeader from "../components/CommandHeader";
import { ProjectList } from "../helpers/ProjectList";

function Projects() {
    return (
        <div className="mx-auto max-w-5xl px-6 py-12">
            <CommandHeader command="ls ~/projects" />
            <h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Things I've built</h1>
            <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {ProjectList.map((project) => (
                    <ProjectItem
                        key={project.id}
                        id={project.id}
                        name={project.name}
                        image={project.image}
                        tools={project.tools}
                    />
                ))}
            </div>
        </div>
    );
}

export default Projects;
